module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.6d8f7876.jpeg";